import React from "react";
import "./Veeners.css";
import Teeth_Whiting_img from "../images/asian-smile-3672997_1920.jpg";
export default function Veeners() {
  return (
    <div className="container_Veeners">
      <h1>Veeners</h1>
      <div className="img_box_Veeners_">
        <img src={Teeth_Whiting_img} className="img_of_Veeners" alt="" />
      </div>
      <div className="text_main_Veeners">
        <p>
          Dental facade – otherwise called overlays – are utilized to
          cosmetically improve the presence of at least one or more teeth.
          Facade are thin, porcelain or sap shells that are modified for an
          attractive shape. They are clung to the surface of the teeth to
          reshape broken, distorted or sporadic teeth and in addition give an
          answer for stained teeth that don't react to conventional brightening
          medicines.
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          that dental facade are a moderate method for totally making over your
          grin. Indeed, facade are a go-to corrective system that has turned out
          to be mainstream with big celebrities who need a more brilliant and
          more symmetrical grin. The White dental practitioners are sufficiently
          experienced to expel the contaminated mash, find every one of the
          trenches, close them totally, and legitimately put a dental crown on
          it.
        </p>
        <div className="FAQ_Service_Veeners">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
